import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import {
  TurnIdParam,
  TurnReportResource,
  turnReportsCreateTurnReport,
} from '~/generated';
import { extractData } from '~/utils/query-utils';

export const useCreateTurnReport = (
  options: UseMutationOptions<
    TurnReportResource,
    unknown,
    TurnIdParam,
    unknown
  > = {}
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (turnReport) =>
      extractData(
        turnReportsCreateTurnReport({
          body: turnReport,
        })
      ),
    ...options,
    onSuccess(...args) {
      queryClient.invalidateQueries({
        queryKey: ['TurnReports'],
      });
      queryClient.invalidateQueries({
        queryKey: ['turnsWithoutReport'],
      });
      options.onSuccess?.(...args);
    },
  });
};
